import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/useAxios";
import useApp from "../../../../Hooks/useApp";

const initDoc = [];

function useTable() {
  const [limit, setLimit] = useState(10);
  const [docs, setDocs] = useState(initDoc);
  const [isLoading, setIsLoading] = useState(true);
  const [isFiltered, setIsFiltered] = useState(false);
  const request = useAxios();
  const { user } = useApp();

  // Pagination
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  const [order, setOrder] = useState("id-desc");

  const refetchDocs = () => getDocs({ page, limit });

  const [shipmentId, setShipmentId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  useEffect(() => {
    getDocs({ page, limit });
  }, [page, limit, order]);

  async function getDocs({ page, limit }) {
    const res = await request({
      method: "GET",
      url: "shipments/all",
      params: { page, limit, order },
      show_loading: false,
      loadingFunc: setIsLoading,
    });

    if (res === "error") return;

    setTotal(res?.pagination?.total || 0);
    setPages(res?.pagination?.pages || 0);
    setHasNextPage(res?.pagination?.hasNextPage || false);
    setHasPrevPage(res?.pagination?.hasPrevPage || false);
    setDocs(res?.docs || initDoc);
  }

  async function clearFilters() {
    setIsFiltered(false);
  }

  function handleNext() {
    if (hasNextPage) setPage((prev) => prev + 1);
  }

  function handlePrev() {
    if (hasPrevPage) setPage((prev) => prev - 1);
  }

  async function handleDelete() {
    const res = await request({
      method: "DELETE",
      url: `shipments/delete/${shipmentId}`,
    });

    if (res !== "error") {
      setShowDeleteModal(false);
      refetchDocs();
    }
  }

  async function handleApprove() {
    const res = await request({
      method: "PUT",
      url: "shipments/approve",
      body: {
        id: shipmentId,
        status: "set for delivery", // assuming approval sets it to in_transit
        approved_by: user?.id,
      },
    });

    if (res !== "error") {
      setShowApproveModal(false);
      refetchDocs();
    }
  }

  async function handleCancel() {
    const res = await request({
      method: "PUT",
      url: "shipments/cancel",
      body: {
        id: shipmentId,
        status: "cancelled",
      },
    });

    if (res !== "error") {
      setShowCancelModal(false);
      refetchDocs();
    }
  }

  return {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination: {
      page,
      total,
      pages,
      hasNextPage,
      hasPrevPage,
      handleNext,
      handlePrev,
      limit,
      setLimit,
      total_docs: docs.length || 0,
    },
    setOrder,
    clearFilters,
    refetchDocs,
    shipmentId,
    setShipmentId,
    showDeleteModal,
    setShowDeleteModal,
    showApproveModal,
    setShowApproveModal,
    showCancelModal,
    setShowCancelModal,
    handleDelete,
    handleApprove,
    handleCancel,
  };
}

export default useTable;
